module.exports = __webpack_public_path__ + "static/media/curd.1d71fa3c.jpg";